import React from "react";
import CardIcon from "../CardIcon";
import { Card, Row, Col } from "react-bootstrap";
import * as Assets from "../../../utils/svg_assets";
import "./style.scss";

const CardContent = (props) => {
  const dataIcon = [
    {
      icon: Assets.iconLikeSolid,
      count: props.likeCount,
    },
    {
      icon: Assets.iconCommentSolid,
      count: props.commentCount,
    },
    {
      icon: Assets.iconView,
      count: props.viewCount,
    },
  ];
  return (
    <Card className="card-list-polling">
      <div className="card-top">
        <img src={Assets.iconPolling} alt="logo_image" />
        <div className="title-wrapper">
          <span className="title">{props.title}</span>
        </div>
      </div>
      <Row className="pt-1">
        <Col xs={7} sm={7} md={7}>
          <div className="card-details">
            <img src={Assets.iconGoldCoin} alt="logo_image" />
            <div className="point-wrapper">
              <span className="point">
                Get {props.points} {props.currency}
              </span>
            </div>
          </div>
        </Col>
        <Col xs={5} sm={5} md={5} className="text-center">
          <div className={`btn btn-sm btn-action`} onClick={props.onClick}>
            {props.buttonText}
          </div>
        </Col>
      </Row>
      <div className="polling-info">
        {dataIcon &&
          dataIcon.map((a, index) => (
            <CardIcon key={index} icon={a.icon} count={a.count} />
          ))}
      </div>
      <Row className="pt-2">
        <Col xs={7} sm={7} md={7}>
          <div className="card-bottom-left">
            <span className="text">Posted by {props.creator}</span>
          </div>
        </Col>
        <Col xs={5} sm={5} md={5} className="text-center">
          <div className="card-bottom-right">
            <span className="text">{props.countDays} days ago</span>
          </div>
        </Col>
      </Row>
    </Card>
  );
};

export default CardContent;
